import { createAction, props } from '@ngrx/store';
import { ZoneSubscription } from '../../../zones/models/zone-subscription';
import { ChangeStateModel } from '../../../zones/models/change-state-model';
import { ZoneUnitsSubscription } from '../../../zones/models/zone-units-subscription';

export const getZonesSubscriptionsSuccess = createAction(
  '[ZonesSubscriptions/API] Get Zones Subscriptions Success',
  props<{data: ZoneSubscription[]}>()
);
export const getZonesSubscriptionsFailure = createAction(
  '[ZonesSubscriptions/API] Get Zones Subscriptions Failure',
  props<{error: any}>()
);

export const createZoneSubscriptionSuccess = createAction(
  '[ZonesSubscriptions/API] Create Zone Subscription Success',
  props<{data: ZoneSubscription}>()
);
export const createZoneSubscriptionFailure = createAction(
  '[ZonesSubscriptions/API] Create Zone Subscription Failure',
  props<{error: any}>()
);

export const editZoneSubscriptionSuccess = createAction(
  '[ZonesSubscriptions/API] Edit Zone Subscription Success',
  props<{data: ZoneSubscription}>()
);
export const editZoneSubscriptionFailure = createAction(
  '[ZonesSubscriptions/API] Edit Zone Subscription Failure',
  props<{error: any}>()
);

export const editUnitsZoneSubscriptionSuccess = createAction(
    '[ZonesSubscriptions/API] Edit Units Zone Subscription',
    props<{data: ZoneUnitsSubscription}>()
    );

export const editUnitsZoneSubscriptionFailure = createAction(
    '[ZonesSubscriptions/API] Edit Units Zone Subscription Failure',
    props<{error: any}>()
    );

export const deleteZoneSubscriptionSuccess = createAction(
  '[ZonesSubscriptions/API] Delete Zone Subscription Success',
  props<{zoneId: number}>()
);
export const deleteZoneSubscriptionFailure = createAction(
  '[ZonesSubscriptions/API] Delete Zone Subscription Failure',
  props<{error: any}>()
);

export const changeStateSuccess = createAction(
  '[ZonesSubscriptions/API] Change State Success',
  props<{data: ChangeStateModel}>()
);
export const changeStateFailure = createAction(
  '[ZonesSubscriptions/API] Change State Failure',
  props<{error: any}>()
);

export type ZonesSubscriptionsApiActionsUnion = ReturnType<
  typeof getZonesSubscriptionsSuccess |
  typeof getZonesSubscriptionsFailure |
  typeof createZoneSubscriptionSuccess |
  typeof createZoneSubscriptionFailure |
  typeof editZoneSubscriptionSuccess |
  typeof editZoneSubscriptionFailure |
  typeof editUnitsZoneSubscriptionSuccess |
  typeof editUnitsZoneSubscriptionFailure |
  typeof deleteZoneSubscriptionSuccess |
  typeof deleteZoneSubscriptionFailure |
  typeof changeStateSuccess |
  typeof changeStateFailure
  >;
